import React from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';

import Button from '@style-guide/components/Button';

import Divider from '@components/Divider';

import ButtonWrapper from './shared/ButtonWrapper';
import Inner from './shared/Inner';
import ItemTitle from './shared/ItemTitle';
import ItemWrapper from './shared/ItemWrapper';
import NoResultsMessage from './shared/NoResultsMessage';
import Title from './shared/Title';
import Wrapper from './shared/Wrapper';

class SitePagesSection extends React.Component {
  constructor() {
    super();

    this.state = {
      increment: 10,
      pageMax: 10,
    };

    this.updatePageMax = this.updatePageMax.bind(this);
    this.renderItems = this.renderItems.bind(this);
  }

  updatePageMax() {
    this.setState({
      pageMax: this.state.pageMax + this.state.increment,
    });
  }

  renderItems() {
    const {
      pageMax,
    } = this.state;
    const { items } = this.props;
    const itemsWithIds = items.map((x, index) => ({
      ...x,
      id: index,
    }));

    const itemsToRender = itemsWithIds.map((resource, index) => {
      if (index > pageMax - 1) {
        return undefined;
      }

      return (
        <React.Fragment
          key={resource.id}
        >
          {index > 0 && (
            <Divider
              hasDecorator={false}
              margin="15px 0px"
            />
          )}
          <ItemWrapper
            href={resource.Url}
          >
            <ItemTitle>{resource.Name}</ItemTitle>
          </ItemWrapper>
        </React.Fragment>
      );
    });

    return itemsToRender;
  }

  render() {
    const {
      items,
      keyword,
    } = this.props;

    return (
      <Wrapper
        hasTopMargin
      >
        <Title>Site Pages ({items.length})</Title>
        <Inner>
          {is.not.empty(items) && this.renderItems()}
          {is.empty(items) && keyword && (
            <React.Fragment>
              <NoResultsMessage>No Results found.</NoResultsMessage>
            </React.Fragment>
          )}
          {is.empty(items) && !keyword && (
            <React.Fragment>
              <NoResultsMessage>Please enter a keyword to search site pages.</NoResultsMessage>
            </React.Fragment>
          )}
          {is.not.empty(items) && items.length > this.state.pageMax && (
            <ButtonWrapper>
              <Button
                onClick={() => this.updatePageMax()}
              >
                Show More
              </Button>
            </ButtonWrapper>
          )}
        </Inner>
      </Wrapper>
    );
  }
}

SitePagesSection.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  keyword: PropTypes.string,
};

SitePagesSection.defaultProps = {
  keyword: '',
};

SitePagesSection.displayName = 'SitePagesSection';

export default SitePagesSection;
